/**
 * Maaş hesabı sabitleri.
 */

/** Aylık standart saat. Aylık ücretliler için: aylıkMaaş ÷ 300 = saatlik karşılık. */
export const AYLIK_STANDART_SAAT = 300

/** Bir izin gününe karşılık gelen saat. */
export const IZIN_GUN_SAAT_KARSILIGI = 10

/** Mola hakkı dakika cinsinden (1.5 saat). Aşan dakika maaştan düşer. */
export const MOLA_HAKKI_DK = 90
